import { Localized } from '../../../utilities/localizedStrings';
import { Spinner as FluentSpinner } from '@fluentui/react/lib/Spinner';

/**
 * A spinner with optional verb label and ellipsis
 *  
 * @param {object} props - label, appendEllipsis
 * @returns - a fluentui Spinner component
 */
export const Spinner = (props) => {
    const { label, appendEllipsis } = props;    
    let labelText = label || Localized.get('loading');
    if (appendEllipsis) {
        labelText += '...';
    }
    
    return (
        <FluentSpinner {...props} label={labelText} />
    );
}
